import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AdminAuthProvider } from "@/auth/AdminAuthContext";
import { EmployerAuthProvider } from "@/auth/EmployerAuthContext";
import { SiteContentProvider } from "@/content/SiteContentContext";
import SiteHeader from "@/components/SiteHeader";
import CompanyFooter from "@/components/CompanyFooter";
import PageTitle from "@/components/PageTitle";
import { GlobalStructuredData } from "@/components/StructuredData";
import AdminAccessPage from "@/pages/AdminAccessPage";
import AdminWorkspacePage from "@/pages/AdminWorkspacePage";
import EmployerAuthGooglePage from "@/pages/EmployerAuthGooglePage";
import EmployerForgotPasswordPage from "@/pages/EmployerForgotPasswordPage";
import EmployerGoogleCallbackPage from "@/pages/EmployerGoogleCallbackPage";
import EmployerResetPasswordPage from "@/pages/EmployerResetPasswordPage";
import EmployerDashboardV2 from "@/pages/EmployerDashboardV2";
import EmployerPage from "@/pages/EmployerPage";
import HomePage from "@/pages/HomePage";
import JobDetailsViewPage from "@/pages/JobDetailsViewPage";
import BlogDetailPage from "@/pages/BlogDetailPage";
import BlogsPage from "@/pages/BlogsPage";
import GalleryPage from "@/pages/GalleryPage";

function AppShell() {
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith("/admin");
  const isEmployerRoute = pathname.startsWith("/employer/");
  const content = <>
    <PageTitle />
    <GlobalStructuredData />
    <SiteHeader />
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/jobs/:jobId" element={<JobDetailsViewPage />} />
      <Route path="/employers" element={<EmployerPage />} />
      <Route path="/blog" element={<BlogsPage />} />
      <Route path="/blog/:postId" element={<BlogDetailPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/admin/login" element={<AdminAccessPage />} />
      <Route path="/admin" element={<AdminWorkspacePage />} />
      <Route path="/employer/login" element={<EmployerAuthGooglePage />} />
      <Route path="/employer/google-callback" element={<EmployerGoogleCallbackPage />} />
      <Route path="/employer/forgot-password" element={<EmployerForgotPasswordPage />} />
      <Route path="/employer/reset-password" element={<EmployerResetPasswordPage />} />
      <Route path="/employer/dashboard" element={<EmployerDashboardV2 />} />
    </Routes>
    <CompanyFooter />
  </>;
  if (isAdminRoute) return <AdminAuthProvider>{content}</AdminAuthProvider>;
  if (isEmployerRoute) return <EmployerAuthProvider>{content}</EmployerAuthProvider>;
  return content;
}

function App() {
  return (
    <SiteContentProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </SiteContentProvider>
  );
}

export default App;
